import { CATEGORY_ALIAS } from "../types/talk";

import { MANAGER_ROLE } from "../consts/member";

import { UserState } from "../contexts/userContext";

import {
  PostUserItem,
  TalkCategory,
  TalkListItem,
} from "../services/talkServices";

export const getWritable = (category: TalkCategory, user: UserState) => {
  // 샌디 운영자 또는 공지 매니저만 가능
  if (
    [
      CATEGORY_ALIAS.BUILDING_MENU,
      CATEGORY_ALIAS.BUILDING_EVENT,
      CATEGORY_ALIAS.BUILDING_NOTICE,
    ].includes(category?.alias ?? "") &&
    !user.roles?.includes(MANAGER_ROLE.CAFETERIA) &&
    !user.roles?.includes(MANAGER_ROLE.ADMIN)
  ) {
    return false;
  }

  if (
    CATEGORY_ALIAS.BUILDING_MENU === category.alias &&
    (!category.storeList || category.storeList.length <= 0)
  ) {
    return false;
  }

  // 현장 매니저 + 샌디 운영자
  if (
    [CATEGORY_ALIAS.BUILDING_MANAGER].includes(category.alias ?? "") &&
    !user.roles?.includes(MANAGER_ROLE.ADMIN) &&
    !user.roles?.includes(MANAGER_ROLE.FIELD) &&
    !user.roles?.includes(MANAGER_ROLE.MANAGER) &&
    !user.roles?.includes(MANAGER_ROLE.CAFETERIA)
  ) {
    return false;
  }

  if (
    [
      CATEGORY_ALIAS.TALK_SANDI_EVENT,
      CATEGORY_ALIAS.SANDI_FAQ,
      "talk-sandi-event", // 확인 후 삭제 필요
    ].includes(category?.alias ?? "") &&
    !user.roles?.includes(MANAGER_ROLE.ADMIN)
  ) {
    // 샌디 운영자만 가능
    return false;
  }

  return true;
};

export const getReadable = (category: TalkCategory, user: UserState) => {
  if (
    category.alias === CATEGORY_ALIAS.BUILDING_MANAGER &&
    !user.roles?.includes(MANAGER_ROLE.ADMIN) &&
    !user.roles?.includes(MANAGER_ROLE.FIELD) &&
    !user.roles?.includes(MANAGER_ROLE.MANAGER) &&
    !user.roles?.includes(MANAGER_ROLE.CAFETERIA) &&
    !user.roles?.includes(MANAGER_ROLE.CALL_CENTER)
  ) {
    return false;
  }

  return true;
};

export const formatPostTitle = (title?: string, replace: string = "") => {
  if (!title) return replace;
  if (title === "-") return replace;
  return title;
};

export const onLikePost = (post: TalkListItem, user: UserState) => {
  return {
    ...post,
    postLike: {
      ...post.postLike,
      likeCount: post.postLike.userLiked
        ? post.postLike.likeCount - 1
        : post.postLike.likeCount + 1,
      userLiked: !post.postLike.userLiked,
      userList: post.postLike.userLiked
        ? post.postLike.userList.filter((item) => item.userId !== user.memberId)
        : [
            ...post.postLike.userList,
            {
              userId: user.memberId,
              userName: user.name,
              userNickname: user.nickname,
              fileInfo: {
                items: user?.profileImage?.filePath
                  ? [
                      {
                        scale: "small",
                        url: user?.profileImage?.filePath,
                      },
                    ]
                  : [],
              },
            } as PostUserItem,
          ],
    },
  };
};

export const replaceTabName = (name: string) => {
  if (name === "토크") return "샌디톡";
  return name + "톡";
};
